import DepsService from 'services/dependencies';

const CONTEXT = 'media-templates';

export const fetchMediaTemplate = async (posterName) => {
  const url = DepsService.rest.cms.mediaTemplate.get.url;
  const urlParams = { posterName };
  const queryParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const updateMediaTemplate = async (data) => {
  const url = DepsService.rest.cms.mediaTemplate.update.url;

  return DepsService.restSrv.update(CONTEXT, url, data);
};

export const previewMediaTemplate = async (previewData) => {
  const url = DepsService.rest.cms.mediaTemplate.preview.url;
  const urlParams = {};
  const headers = {
    responseType: 'arraybuffer',
  };

  return DepsService.restSrv.create(CONTEXT, url, previewData, urlParams, headers);
};

export const fetchFonts= async () => {
  const url = DepsService.rest.cms.mediaTemplate.fonts.url;
  const urlParams = {};
  const queryParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/media-templates.api.js